import React, { useState } from "react";
import { isEmpty } from "lodash";
import axios from "axios";

import dummyAvatar from "assets/images/sbs/dummyAvatar.png";
import OnboardingModal from "components/heylime-layout/components/OnboardingModal";
import { ReactComponent as CrossSvg } from "assets/images/heylime-layout/cross.svg";
import Alert from "components/shared/common/alert";

const MyTeam = ({
  history,
  currentUser,
  handleIsLoading,
  handleSetCurrentUser
}) => {
  const isManager = currentUser.userId === currentUser.team?.manager;
  const users = currentUser.team?.users;
  const filteredUsers = currentUser.team?.users.filter(
    (user) => user.Username !== currentUser.team?.manager && user
  );

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [teamDropdown, setTeamDropdown] = useState(false);
  const [selectedManager, setSelectedManager] = useState({});
  const [viewAllMembers, setViewAllMembers] = useState(false);

  const toggleModal = () => setIsOpenModal((prev) => !prev);
  const toggleViewAll = () => setViewAllMembers((prev) => !prev);
  const toggleTeamDropdown = () => setTeamDropdown(!teamDropdown);

  const updateManager = async () => {
    if (isEmpty(selectedManager)) return Alert(400, "Please select a manager");
    try {
      handleIsLoading(true);
      const url = process.env.REACT_APP_CHANGE_MANAGER;
      const response = await axios.post(url, {
        team_code: currentUser.team?.id,
        current_manager_id: currentUser.team?.manager,
        new_manager_id: selectedManager.Username
      });
      handleSetCurrentUser("team", response?.data?.Attributes);
      toggleModal();
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      handleIsLoading(false);
    }
  };

  const handleSelectedManager = (user) => {
    toggleTeamDropdown();
    setSelectedManager(user);
  };

  const formattedText = (
    <p className="desc bottom-text">
      <span>Note</span>: There can only be <u>one manager per team</u>, so{" "}
      <u>updating your team’s manager will remove you as manager</u> and update
      the role to your select teammate.
    </p>
  );

  return (
    <div
      className={`my-image my-team ${
        isEmpty(currentUser.team) ? "no-team" : ""
      } ${viewAllMembers ? "view-all" : ""}`}
    >
      {isEmpty(currentUser.team) ? (
        <div className="no-team-div">
          <h2 className="no-team-text no-team">User doesn't have a team.</h2>
          <button
            onClick={() => history.push("/trial-login")}
            className="btn btn-primary no-team-btn"
          >
            Get Team
          </button>
        </div>
      ) : viewAllMembers ? (
        <div className="all-members-main">
          <div className="member-header">
            <h2 className="heading">All Teammates</h2>
            <CrossSvg className="cross" onClick={toggleViewAll} />
          </div>
          <div className="member-scroll">
            {users.map((item) => (
              <div key={item.user_id} className="member-div">
                <img alt="" src={item.picture || dummyAvatar} />
                <span>{item.name}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
          <div className="content" style={{ width: "100%" }}>
            <h4 className="name">My Team</h4>
            <p className="desc">
              View your current team name, teammates, and team admin.
            </p>
          </div>
          <div className="mt-5">
            <input
              disabled
              type="text"
              onChange={() => {}}
              className="form-control input-2"
              value={currentUser.team?.description}
            />
          </div>
          <div className="teammates">
            <div className="d-flex">
              {users.map(
                (item, index) =>
                  index < 5 && (
                    <img
                      key={index}
                      src={item.picture || dummyAvatar}
                      className={`profile-1 ${
                        true ? "profile-2 " : ""
                      } img-fluid`}
                      alt="profile1"
                    />
                  )
              )}
              <h4 className="mb-0">{`Teammates (${users.length})`}</h4>
            </div>
            <span className="all" onClick={toggleViewAll}>
              View All
            </span>
          </div>
          <button
            disabled={!isManager}
            className="upload-btn"
            onClick={toggleModal}
          >
            Edit Team Manager
          </button>
        </>
      )}
      <OnboardingModal
        inputType=""
        isDropdown={true}
        isOpen={isOpenModal}
        toggle={toggleModal}
        users={filteredUsers}
        dropdown={teamDropdown}
        btnText1="Update Manager"
        btnClick1={updateManager}
        bottomText={formattedText}
        title="Update Team Manager"
        dropdownValue={selectedManager}
        toggleDropDown={toggleTeamDropdown}
        dropdownSelect={handleSelectedManager}
        desc="You are currently (Team Name)’s Admin. Select a teammate to update as your team’s new admin."
      />
    </div>
  );
};

export default MyTeam;
